<template>
  <div style="width: 100%; height: 100%">

    <div class="centered-child" style="padding-bottom: 16px">
      <div style="width: 100%; max-width: 200px">
      <img src="/static/justice-scale.svg" width="100%">
      </div>
    </div>

    <h2>Application for a visa for France</h2>

    <p>
      You mentioned that you did not apply for a visa yet. </p>
    <p>Our lawyers can help you to build your application file and write a cover letter. Ce service est un service premium (999€ TTC). </p>
    <p>Pour y souscrire, il vous suffit de cliquer sur ce lien suivant : XXX</br>
    </p>
    <p>
      Sinon nous vous invitons à effectuer une demande de visa auprès des services consulaires français <a href="https://www.service-public.fr/particuliers/vosdroits/N105">for more information</a>.
    </p>
    <p>
      réalisé une demande de visa
If you have made a mistake in your answers and you have already applied for a visa, you can <router-link to="/">restart our questionnaire</router-link>.
    </p>

  </div>
</template>


<script>
import ServiceAccess from '../service/ServiceAccess'

export default {
  created: function () {
    global.navigationBarBus.$on('navigation-back', this.prevScreen)
    global.navigationBarBus.$emit('navigation-display-back', true)
    global.navigationBarBus.$emit('display-save', false)

    ServiceAccess.instance.track(this.$route.params.sessionId, 'screen-ko', {kind: 'Demande Visa'})
  },
  destroyed: function () {
    global.navigationBarBus.$off('navigation-back', this.prevScreen)
  },
  methods: {
    prevScreen: function () {
      this.$router.back()
    }
  }


}
</script>



// WEBPACK FOOTER //
// ScreenDemandeVisa.vue?66e35d4d